var map = {
	"./csv.svg": 2328,
	"./doc.svg": 7444,
	"./generic.svg": 458,
	"./jpeg.svg": 65,
	"./jpg.svg": 4047,
	"./pdf.svg": 2113,
	"./pdficon.png": 8323,
	"./pdficon.svg": 6181,
	"./png.svg": 358,
	"./ppt.svg": 3073,
	"./txt.svg": 395,
	"./xls.svg": 2248,
	"./xlss.svg": 4967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9914;